import React from "react";
import { Route, Routes } from "react-router-dom";
import AccountCredits from "./AccountCredits";

const AccountCreditsMspa: React.FC = () => (
  <Routes>
    <Route path="/" element={<AccountCredits />} />
  </Routes>
);

export default AccountCreditsMspa;
